import React from 'react'
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap'

const Transactions = (props) => {
  return (
    <div>
    <Modal isOpen={props.transaction_alert} style={{ maxWidth: '75%', width: '75%' }}>
        <ModalHeader style={{fontWeight:'bold', color:'darkblue'}}>Last 25 Transactions</ModalHeader>
        <ModalBody style={{fontStyle:"italic", color:'grey'}}>
            {/* This is the last 25 transaction statement for your reference <br/> */}

            <div className='row'>
            <div className='col-12'>
            <div className='table-responsive'>
            <table className="table table-striped table-bordered">
              <thead style={{position: "sticky", top: '0px'}}>
                <tr>
                  <th className="text-center">transaction_id</th>
                  <th className="text-center">email</th>
                  <th className="text-center">transaction_type</th>
                  <th className="text-center">amount</th>
                  <th className="text-center">description</th>
                  <th className="text-center">transaction_date</th>
                  <th className="text-center">balance_amount</th>
                </tr>
              </thead>
              <tbody>
              {props.statements !== null && Array.isArray(props.statements) && props.statements.map( (statement, index) => 
              
              <tr key={index}>
                <td className="text-center">{statement.transaction_id}</td>
                <td className="text-center">{statement.email}</td>
                <td className="text-center">{statement.transaction_type}</td>
                <td className="text-center">₹.{statement.amount}/-</td>
                <td className="text-center">{statement.description}</td>
                <td className="text-center">{statement.transaction_date}</td>
                <td className="text-center">₹.{statement.balance_amount}/-</td>
              </tr>
              
              )}
              </tbody>
            </table>
            </div>
            </div>
            </div>

        </ModalBody>
        <ModalFooter>
            <Button color="primary" onClick={props.toggle_transaction_alert}>Ok</Button>
        </ModalFooter>
    </Modal>
    </div>
  )
}

export default Transactions